import { authAxiosClient } from '@/lib';
import { PaginatedApiResponse, PaginatedData } from '@/types';
import { withLogger } from '@/utils';

import { experiencesAPIUrls } from '../data';
import { Experiences } from '../types';

type Param = {
  search: string;
  year: number;
  page: number;
  rowsPerPage: number;
};

type ListExperiences = Array<Experiences>;
// type Return = PaginatedData<Array<Experiences>>;
type Return = {
  data: Experiences[];
  total: number;
};

export type GetExperiences = {
  param: Param;
  return: Return;
};

export const getExperiences = withLogger(
  async ({ search, year, page, rowsPerPage: limit }: Param): Promise<Return> => {
    const res = await authAxiosClient.get<{
      message: string;
      data: Experiences[];
      pagination: {
        currentPage: number;
        totalPages: number;
        limit: number;
        totalItems: number;
        nextPage: number | null;
        prevPage: number | null;
      };
    }>(experiencesAPIUrls.getExperiences, {
      params: { search, year, page, limit },
    });

    return {
      data: res.data.data,
      total: res.data.pagination.totalItems,
    };
  }
);